import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { ChevronLeft, LogOut } from "lucide-react";
import RecoveryRoutine from "@/pages/RecoveryRoutine";

export default function PlayerRecoveryShell() {
  const { logout } = useAuth();
  const nav = useNavigate();
  const [suggested, setSuggested] = useState(null);

  useEffect(() => {
    // Pre-select today's recovery to the engine's hybrid suggestion
    api.get("/players/me/profile")
      .then((r) => setSuggested(r.data?.readiness?.suggested_hybrid || null))
      .catch(() => {});
  }, []);

  const handleLogout = async () => { await logout(); nav("/", { replace: true }); };

  return (
    <div className="min-h-screen pb-16" style={{ backgroundColor: "var(--ink-1)" }} data-testid="player-recovery-page">
      <header className="sticky top-0 z-30 backdrop-blur-xl border-b border-[var(--ink-border)]" style={{ backgroundColor: "rgba(10,20,36,0.85)" }}>
        <div className="max-w-5xl mx-auto px-5 py-4 flex items-center justify-between">
          <Logo size="sm" variant="lockup" linkTo="/portal" dark />
          <Button variant="ghost" size="sm" onClick={handleLogout} className="text-white/70 hover:text-white hover:bg-white/5" data-testid="recovery-logout-button">
            <LogOut className="h-4 w-4 mr-1.5" /> Sign out
          </Button>
        </div>
      </header>
      <div className="max-w-5xl mx-auto px-5 pt-6">
        <Link to="/portal" className="inline-flex items-center text-sm text-white/50 hover:text-white" data-testid="back-to-portal">
          <ChevronLeft className="h-4 w-4" /> Back to today's log
        </Link>
        <div className="mt-6">
          <RecoveryRoutine defaultLetter={suggested} />
        </div>
      </div>
    </div>
  );
}
